import { render, staticRenderFns } from "./LoginLogs.vue?vue&type=template&id=ff9a96ee&scoped=true"
import script from "./LoginLogs.vue?vue&type=script&lang=js"
export * from "./LoginLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9a96ee",
  null
  
)

export default component.exports